<template>
  <div class="floot">
    <div class="contion">
      <div class="pic">
        <div class="pic-left">
          <img src="../../assets/5ac_39.gif" alt="" />
        </div>
        <div class="pic-right">
          <img src="../../assets/5ac_42.gif" alt="" />
          <img src="../../assets/5ac_44.gif" alt="" />
        </div>
      </div>
      <div class="text">
        <p>联系电话 010-8275 4334</p>
        <p>商务 QQ：574768865</p>
        <p>商务邮箱：wangjin @dongsport .com</p>
        <p>地址：北京市通州区观音磨难街1号楼2单元22层19356</p>
      </div>
      <div class="last">
        <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
            <span>Copyright @ 2022
              国体智慧云动（北京）科技有限公司 xinyundong.com.cn All Reserved 京ICP备2022023939号-1</span>
          </a>

        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.floot {
  width: 100%;
  height: 326px;
  background: #111811;
}

.floot .contion {
  width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
}

.floot .contion .pic {
  display: flex;
  justify-content: space-between;
}

.floot .contion .pic .pic-right img {

  margin-top: 30px;
  margin-left: 10px;
}

.floot .contion .text {
  width: 1200px;
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}

.floot .contion .text p {
  color: #fff;
  padding-top: 40px;
  font-size: 10px;
}

.floot .contion .last {
  height: 30px;
  width: 100%;
  margin-top: 60px;
  border-top: 1px solid rgba(255, 255, 255, 0.1000);
}

.floot .contion .last p {
  text-align: center;
  color: rgba(255, 255, 255, 0.7000);
  font-size: 12px;
}

style>

/* 初始样式 */
a {
  text-decoration: none;
  /* 去掉下划线 */
  color: #000000;
  /* 链接初始颜色 */
}

/* 悬停样式 */
a:hover {
  color: #FF5733;
  /* 悬停时的颜色 */
  transition: color 0.3s ease;
  /* 颜色变化的过渡效果 */
}

span {
  font-size: 14px;
  /* 设置字体大小 */
  color: #409eff;
  /* 初始文字颜色 */
}

/* 悬停时span内文字的颜色 */
a:hover span {
  color: #FF5733;
  /* 悬停时文字颜色 */
}
</style>
